import { WorkItemType } from '@types';

import { WorkItem } from '../workItem/WorkItem';

import styles from './worksList.module.scss';

export interface WorkItemsListProps {
	works: WorkItemType[];
	onItemClick: (work: WorkItemType, index: number) => void;
	selectedIndex: number;
}

export const WorksList = ({ works, onItemClick, selectedIndex }: WorkItemsListProps) => {
	return (
		<div className={styles.wrapper} data-testid="worksList">
			<div className={styles[`work-list`]}>
				<table aria-label="work list">
					<thead>
						<tr className={styles[`work-list-header`]} aria-label="work list - header">
							<th>Works reference</th>
							<th>Works type </th>
							<th>Status </th>
							<th> </th>
						</tr>
					</thead>
					<tbody>
						{works.map((work, ind) => (
							<WorkItem
								work={work}
								key={`${work.id}-${ind}`}
								onItemClick={work => onItemClick(work, ind)}
								selected={selectedIndex === ind}
							/>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
